export default {
  small: '768px',
  medium: '992px',
  large: '1440px'
};
